import * as ee from "react";
import Kr, { forwardRef as lr, useContext as Ft, useRef as Ir, useEffect as Mt, createContext as jt, Children as De } from "react";
import { globalColor as Le, illaPrefix as Ve, applyBoxStyle as Zr, deleteCssProps as Xr } from "@illa-design/theme";
import { css as G } from "@emotion/react";
import { PeopleIcon as zt } from "@illa-design/icon";
import { Image as Lt } from "@illa-design/image";
var or = { exports: {} }, Ee = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Dr;
function Vt() {
  if (Dr)
    return Ee;
  Dr = 1;
  var e = Kr, r = Symbol.for("react.element"), t = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function c(f, d, v) {
    var p, y = {}, R = null, N = null;
    v !== void 0 && (R = "" + v), d.key !== void 0 && (R = "" + d.key), d.ref !== void 0 && (N = d.ref);
    for (p in d)
      a.call(d, p) && !i.hasOwnProperty(p) && (y[p] = d[p]);
    if (f && f.defaultProps)
      for (p in d = f.defaultProps, d)
        y[p] === void 0 && (y[p] = d[p]);
    return { $$typeof: r, type: f, key: R, ref: N, props: y, _owner: o.current };
  }
  return Ee.Fragment = t, Ee.jsx = c, Ee.jsxs = c, Ee;
}
var ge = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Fr;
function Yt() {
  return Fr || (Fr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Kr, r = Symbol.for("react.element"), t = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), c = Symbol.for("react.provider"), f = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), v = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), y = Symbol.for("react.memo"), R = Symbol.for("react.lazy"), N = Symbol.for("react.offscreen"), P = Symbol.iterator, b = "@@iterator";
    function F(n) {
      if (n === null || typeof n != "object")
        return null;
      var s = P && n[P] || n[b];
      return typeof s == "function" ? s : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function E(n) {
      {
        for (var s = arguments.length, l = new Array(s > 1 ? s - 1 : 0), m = 1; m < s; m++)
          l[m - 1] = arguments[m];
        $("error", n, l);
      }
    }
    function $(n, s, l) {
      {
        var m = x.ReactDebugCurrentFrame, S = m.getStackAddendum();
        S !== "" && (s += "%s", l = l.concat([S]));
        var k = l.map(function(_) {
          return String(_);
        });
        k.unshift("Warning: " + s), Function.prototype.apply.call(console[n], console, k);
      }
    }
    var I = !1, u = !1, z = !1, A = !1, Ge = !1, Ce;
    Ce = Symbol.for("react.module.reference");
    function He(n) {
      return !!(typeof n == "string" || typeof n == "function" || n === a || n === i || Ge || n === o || n === v || n === p || A || n === N || I || u || z || typeof n == "object" && n !== null && (n.$$typeof === R || n.$$typeof === y || n.$$typeof === c || n.$$typeof === f || n.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      n.$$typeof === Ce || n.getModuleId !== void 0));
    }
    function Je(n, s, l) {
      var m = n.displayName;
      if (m)
        return m;
      var S = s.displayName || s.name || "";
      return S !== "" ? l + "(" + S + ")" : l;
    }
    function Re(n) {
      return n.displayName || "Context";
    }
    function H(n) {
      if (n == null)
        return null;
      if (typeof n.tag == "number" && E("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof n == "function")
        return n.displayName || n.name || null;
      if (typeof n == "string")
        return n;
      switch (n) {
        case a:
          return "Fragment";
        case t:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case v:
          return "Suspense";
        case p:
          return "SuspenseList";
      }
      if (typeof n == "object")
        switch (n.$$typeof) {
          case f:
            var s = n;
            return Re(s) + ".Consumer";
          case c:
            var l = n;
            return Re(l._context) + ".Provider";
          case d:
            return Je(n, n.render, "ForwardRef");
          case y:
            var m = n.displayName || null;
            return m !== null ? m : H(n.type) || "Memo";
          case R: {
            var S = n, k = S._payload, _ = S._init;
            try {
              return H(_(k));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var X = Object.assign, re = 0, Te, Oe, le, Pe, de, Ae, $e;
    function Ne() {
    }
    Ne.__reactDisabledLog = !0;
    function Ke() {
      {
        if (re === 0) {
          Te = console.log, Oe = console.info, le = console.warn, Pe = console.error, de = console.group, Ae = console.groupCollapsed, $e = console.groupEnd;
          var n = {
            configurable: !0,
            enumerable: !0,
            value: Ne,
            writable: !0
          };
          Object.defineProperties(console, {
            info: n,
            log: n,
            warn: n,
            error: n,
            group: n,
            groupCollapsed: n,
            groupEnd: n
          });
        }
        re++;
      }
    }
    function Ze() {
      {
        if (re--, re === 0) {
          var n = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: X({}, n, {
              value: Te
            }),
            info: X({}, n, {
              value: Oe
            }),
            warn: X({}, n, {
              value: le
            }),
            error: X({}, n, {
              value: Pe
            }),
            group: X({}, n, {
              value: de
            }),
            groupCollapsed: X({}, n, {
              value: Ae
            }),
            groupEnd: X({}, n, {
              value: $e
            })
          });
        }
        re < 0 && E("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var pe = x.ReactCurrentDispatcher, he;
    function ne(n, s, l) {
      {
        if (he === void 0)
          try {
            throw Error();
          } catch (S) {
            var m = S.stack.trim().match(/\n( *(at )?)/);
            he = m && m[1] || "";
          }
        return `
` + he + n;
      }
    }
    var ve = !1, ae;
    {
      var Xe = typeof WeakMap == "function" ? WeakMap : Map;
      ae = new Xe();
    }
    function h(n, s) {
      if (!n || ve)
        return "";
      {
        var l = ae.get(n);
        if (l !== void 0)
          return l;
      }
      var m;
      ve = !0;
      var S = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var k;
      k = pe.current, pe.current = null, Ke();
      try {
        if (s) {
          var _ = function() {
            throw Error();
          };
          if (Object.defineProperty(_.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(_, []);
            } catch (Q) {
              m = Q;
            }
            Reflect.construct(n, [], _);
          } else {
            try {
              _.call();
            } catch (Q) {
              m = Q;
            }
            n.call(_.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Q) {
            m = Q;
          }
          n();
        }
      } catch (Q) {
        if (Q && m && typeof Q.stack == "string") {
          for (var g = Q.stack.split(`
`), Y = m.stack.split(`
`), D = g.length - 1, M = Y.length - 1; D >= 1 && M >= 0 && g[D] !== Y[M]; )
            M--;
          for (; D >= 1 && M >= 0; D--, M--)
            if (g[D] !== Y[M]) {
              if (D !== 1 || M !== 1)
                do
                  if (D--, M--, M < 0 || g[D] !== Y[M]) {
                    var B = `
` + g[D].replace(" at new ", " at ");
                    return n.displayName && B.includes("<anonymous>") && (B = B.replace("<anonymous>", n.displayName)), typeof n == "function" && ae.set(n, B), B;
                  }
                while (D >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        ve = !1, pe.current = k, Ze(), Error.prepareStackTrace = S;
      }
      var se = n ? n.displayName || n.name : "", kr = se ? ne(se) : "";
      return typeof n == "function" && ae.set(n, kr), kr;
    }
    function me(n, s, l) {
      return h(n, !1);
    }
    function oe(n) {
      var s = n.prototype;
      return !!(s && s.isReactComponent);
    }
    function te(n, s, l) {
      if (n == null)
        return "";
      if (typeof n == "function")
        return h(n, oe(n));
      if (typeof n == "string")
        return ne(n);
      switch (n) {
        case v:
          return ne("Suspense");
        case p:
          return ne("SuspenseList");
      }
      if (typeof n == "object")
        switch (n.$$typeof) {
          case d:
            return me(n.render);
          case y:
            return te(n.type, s, l);
          case R: {
            var m = n, S = m._payload, k = m._init;
            try {
              return te(k(S), s, l);
            } catch {
            }
          }
        }
      return "";
    }
    var ke = Object.prototype.hasOwnProperty, _r = {}, xr = x.ReactDebugCurrentFrame;
    function Ie(n) {
      if (n) {
        var s = n._owner, l = te(n.type, n._source, s ? s.type : null);
        xr.setExtraStackFrame(l);
      } else
        xr.setExtraStackFrame(null);
    }
    function mt(n, s, l, m, S) {
      {
        var k = Function.call.bind(ke);
        for (var _ in n)
          if (k(n, _)) {
            var g = void 0;
            try {
              if (typeof n[_] != "function") {
                var Y = Error((m || "React class") + ": " + l + " type `" + _ + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof n[_] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Y.name = "Invariant Violation", Y;
              }
              g = n[_](s, _, m, l, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (D) {
              g = D;
            }
            g && !(g instanceof Error) && (Ie(S), E("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", m || "React class", l, _, typeof g), Ie(null)), g instanceof Error && !(g.message in _r) && (_r[g.message] = !0, Ie(S), E("Failed %s type: %s", l, g.message), Ie(null));
          }
      }
    }
    var yt = Array.isArray;
    function Qe(n) {
      return yt(n);
    }
    function Et(n) {
      {
        var s = typeof Symbol == "function" && Symbol.toStringTag, l = s && n[Symbol.toStringTag] || n.constructor.name || "Object";
        return l;
      }
    }
    function gt(n) {
      try {
        return Sr(n), !1;
      } catch {
        return !0;
      }
    }
    function Sr(n) {
      return "" + n;
    }
    function wr(n) {
      if (gt(n))
        return E("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Et(n)), Sr(n);
    }
    var ye = x.ReactCurrentOwner, bt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Cr, Rr, er;
    er = {};
    function _t(n) {
      if (ke.call(n, "ref")) {
        var s = Object.getOwnPropertyDescriptor(n, "ref").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return n.ref !== void 0;
    }
    function xt(n) {
      if (ke.call(n, "key")) {
        var s = Object.getOwnPropertyDescriptor(n, "key").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return n.key !== void 0;
    }
    function St(n, s) {
      if (typeof n.ref == "string" && ye.current && s && ye.current.stateNode !== s) {
        var l = H(ye.current.type);
        er[l] || (E('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', H(ye.current.type), n.ref), er[l] = !0);
      }
    }
    function wt(n, s) {
      {
        var l = function() {
          Cr || (Cr = !0, E("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        l.isReactWarning = !0, Object.defineProperty(n, "key", {
          get: l,
          configurable: !0
        });
      }
    }
    function Ct(n, s) {
      {
        var l = function() {
          Rr || (Rr = !0, E("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        l.isReactWarning = !0, Object.defineProperty(n, "ref", {
          get: l,
          configurable: !0
        });
      }
    }
    var Rt = function(n, s, l, m, S, k, _) {
      var g = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: n,
        key: s,
        ref: l,
        props: _,
        // Record the component responsible for creating this element.
        _owner: k
      };
      return g._store = {}, Object.defineProperty(g._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(g, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: m
      }), Object.defineProperty(g, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: S
      }), Object.freeze && (Object.freeze(g.props), Object.freeze(g)), g;
    };
    function Tt(n, s, l, m, S) {
      {
        var k, _ = {}, g = null, Y = null;
        l !== void 0 && (wr(l), g = "" + l), xt(s) && (wr(s.key), g = "" + s.key), _t(s) && (Y = s.ref, St(s, S));
        for (k in s)
          ke.call(s, k) && !bt.hasOwnProperty(k) && (_[k] = s[k]);
        if (n && n.defaultProps) {
          var D = n.defaultProps;
          for (k in D)
            _[k] === void 0 && (_[k] = D[k]);
        }
        if (g || Y) {
          var M = typeof n == "function" ? n.displayName || n.name || "Unknown" : n;
          g && wt(_, M), Y && Ct(_, M);
        }
        return Rt(n, g, Y, S, m, ye.current, _);
      }
    }
    var rr = x.ReactCurrentOwner, Tr = x.ReactDebugCurrentFrame;
    function ie(n) {
      if (n) {
        var s = n._owner, l = te(n.type, n._source, s ? s.type : null);
        Tr.setExtraStackFrame(l);
      } else
        Tr.setExtraStackFrame(null);
    }
    var tr;
    tr = !1;
    function nr(n) {
      return typeof n == "object" && n !== null && n.$$typeof === r;
    }
    function Or() {
      {
        if (rr.current) {
          var n = H(rr.current.type);
          if (n)
            return `

Check the render method of \`` + n + "`.";
        }
        return "";
      }
    }
    function Ot(n) {
      {
        if (n !== void 0) {
          var s = n.fileName.replace(/^.*[\\\/]/, ""), l = n.lineNumber;
          return `

Check your code at ` + s + ":" + l + ".";
        }
        return "";
      }
    }
    var Pr = {};
    function Pt(n) {
      {
        var s = Or();
        if (!s) {
          var l = typeof n == "string" ? n : n.displayName || n.name;
          l && (s = `

Check the top-level render call using <` + l + ">.");
        }
        return s;
      }
    }
    function Ar(n, s) {
      {
        if (!n._store || n._store.validated || n.key != null)
          return;
        n._store.validated = !0;
        var l = Pt(s);
        if (Pr[l])
          return;
        Pr[l] = !0;
        var m = "";
        n && n._owner && n._owner !== rr.current && (m = " It was passed a child from " + H(n._owner.type) + "."), ie(n), E('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', l, m), ie(null);
      }
    }
    function $r(n, s) {
      {
        if (typeof n != "object")
          return;
        if (Qe(n))
          for (var l = 0; l < n.length; l++) {
            var m = n[l];
            nr(m) && Ar(m, s);
          }
        else if (nr(n))
          n._store && (n._store.validated = !0);
        else if (n) {
          var S = F(n);
          if (typeof S == "function" && S !== n.entries)
            for (var k = S.call(n), _; !(_ = k.next()).done; )
              nr(_.value) && Ar(_.value, s);
        }
      }
    }
    function At(n) {
      {
        var s = n.type;
        if (s == null || typeof s == "string")
          return;
        var l;
        if (typeof s == "function")
          l = s.propTypes;
        else if (typeof s == "object" && (s.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        s.$$typeof === y))
          l = s.propTypes;
        else
          return;
        if (l) {
          var m = H(s);
          mt(l, n.props, "prop", m, n);
        } else if (s.PropTypes !== void 0 && !tr) {
          tr = !0;
          var S = H(s);
          E("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", S || "Unknown");
        }
        typeof s.getDefaultProps == "function" && !s.getDefaultProps.isReactClassApproved && E("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function $t(n) {
      {
        for (var s = Object.keys(n.props), l = 0; l < s.length; l++) {
          var m = s[l];
          if (m !== "children" && m !== "key") {
            ie(n), E("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", m), ie(null);
            break;
          }
        }
        n.ref !== null && (ie(n), E("Invalid attribute `ref` supplied to `React.Fragment`."), ie(null));
      }
    }
    function Nr(n, s, l, m, S, k) {
      {
        var _ = He(n);
        if (!_) {
          var g = "";
          (n === void 0 || typeof n == "object" && n !== null && Object.keys(n).length === 0) && (g += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Y = Ot(S);
          Y ? g += Y : g += Or();
          var D;
          n === null ? D = "null" : Qe(n) ? D = "array" : n !== void 0 && n.$$typeof === r ? (D = "<" + (H(n.type) || "Unknown") + " />", g = " Did you accidentally export a JSX literal instead of a component?") : D = typeof n, E("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", D, g);
        }
        var M = Tt(n, s, l, S, k);
        if (M == null)
          return M;
        if (_) {
          var B = s.children;
          if (B !== void 0)
            if (m)
              if (Qe(B)) {
                for (var se = 0; se < B.length; se++)
                  $r(B[se], n);
                Object.freeze && Object.freeze(B);
              } else
                E("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              $r(B, n);
        }
        return n === a ? $t(M) : At(M), M;
      }
    }
    function Nt(n, s, l) {
      return Nr(n, s, l, !0);
    }
    function kt(n, s, l) {
      return Nr(n, s, l, !1);
    }
    var It = kt, Dt = Nt;
    ge.Fragment = a, ge.jsx = It, ge.jsxs = Dt;
  }()), ge;
}
process.env.NODE_ENV === "production" ? or.exports = Vt() : or.exports = Yt();
var Mr = or.exports;
function Wt(e) {
  if (e.sheet)
    return e.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === e)
      return document.styleSheets[r];
}
function Ut(e) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", e.key), e.nonce !== void 0 && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var qt = /* @__PURE__ */ function() {
  function e(t) {
    var a = this;
    this._insertTag = function(o) {
      var i;
      a.tags.length === 0 ? a.insertionPoint ? i = a.insertionPoint.nextSibling : a.prepend ? i = a.container.firstChild : i = a.before : i = a.tags[a.tags.length - 1].nextSibling, a.container.insertBefore(o, i), a.tags.push(o);
    }, this.isSpeedy = t.speedy === void 0 ? process.env.NODE_ENV === "production" : t.speedy, this.tags = [], this.ctr = 0, this.nonce = t.nonce, this.key = t.key, this.container = t.container, this.prepend = t.prepend, this.insertionPoint = t.insertionPoint, this.before = null;
  }
  var r = e.prototype;
  return r.hydrate = function(a) {
    a.forEach(this._insertTag);
  }, r.insert = function(a) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(Ut(this));
    var o = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var i = a.charCodeAt(0) === 64 && a.charCodeAt(1) === 105;
      i && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + a + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !i;
    }
    if (this.isSpeedy) {
      var c = Wt(o);
      try {
        c.insertRule(a, c.cssRules.length);
      } catch (f) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(a) && console.error('There was a problem inserting the following rule: "' + a + '"', f);
      }
    } else
      o.appendChild(document.createTextNode(a));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(a) {
      return a.parentNode && a.parentNode.removeChild(a);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), V = "-ms-", Ye = "-moz-", w = "-webkit-", dr = "comm", pr = "rule", hr = "decl", Bt = "@import", Qr = "@keyframes", Gt = "@layer", Ht = Math.abs, Ue = String.fromCharCode, Jt = Object.assign;
function Kt(e, r) {
  return L(e, 0) ^ 45 ? (((r << 2 ^ L(e, 0)) << 2 ^ L(e, 1)) << 2 ^ L(e, 2)) << 2 ^ L(e, 3) : 0;
}
function et(e) {
  return e.trim();
}
function Zt(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}
function C(e, r, t) {
  return e.replace(r, t);
}
function ir(e, r) {
  return e.indexOf(r);
}
function L(e, r) {
  return e.charCodeAt(r) | 0;
}
function _e(e, r, t) {
  return e.slice(r, t);
}
function K(e) {
  return e.length;
}
function vr(e) {
  return e.length;
}
function Fe(e, r) {
  return r.push(e), e;
}
function Xt(e, r) {
  return e.map(r).join("");
}
var qe = 1, ue = 1, rt = 0, U = 0, j = 0, fe = "";
function Be(e, r, t, a, o, i, c) {
  return { value: e, root: r, parent: t, type: a, props: o, children: i, line: qe, column: ue, length: c, return: "" };
}
function be(e, r) {
  return Jt(Be("", null, null, "", null, null, 0), e, { length: -e.length }, r);
}
function Qt() {
  return j;
}
function en() {
  return j = U > 0 ? L(fe, --U) : 0, ue--, j === 10 && (ue = 1, qe--), j;
}
function q() {
  return j = U < rt ? L(fe, U++) : 0, ue++, j === 10 && (ue = 1, qe++), j;
}
function Z() {
  return L(fe, U);
}
function Me() {
  return U;
}
function we(e, r) {
  return _e(fe, e, r);
}
function xe(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function tt(e) {
  return qe = ue = 1, rt = K(fe = e), U = 0, [];
}
function nt(e) {
  return fe = "", e;
}
function je(e) {
  return et(we(U - 1, sr(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function rn(e) {
  for (; (j = Z()) && j < 33; )
    q();
  return xe(e) > 2 || xe(j) > 3 ? "" : " ";
}
function tn(e, r) {
  for (; --r && q() && !(j < 48 || j > 102 || j > 57 && j < 65 || j > 70 && j < 97); )
    ;
  return we(e, Me() + (r < 6 && Z() == 32 && q() == 32));
}
function sr(e) {
  for (; q(); )
    switch (j) {
      case e:
        return U;
      case 34:
      case 39:
        e !== 34 && e !== 39 && sr(j);
        break;
      case 40:
        e === 41 && sr(e);
        break;
      case 92:
        q();
        break;
    }
  return U;
}
function nn(e, r) {
  for (; q() && e + j !== 47 + 10; )
    if (e + j === 42 + 42 && Z() === 47)
      break;
  return "/*" + we(r, U - 1) + "*" + Ue(e === 47 ? e : q());
}
function an(e) {
  for (; !xe(Z()); )
    q();
  return we(e, U);
}
function on(e) {
  return nt(ze("", null, null, null, [""], e = tt(e), 0, [0], e));
}
function ze(e, r, t, a, o, i, c, f, d) {
  for (var v = 0, p = 0, y = c, R = 0, N = 0, P = 0, b = 1, F = 1, x = 1, E = 0, $ = "", I = o, u = i, z = a, A = $; F; )
    switch (P = E, E = q()) {
      case 40:
        if (P != 108 && L(A, y - 1) == 58) {
          ir(A += C(je(E), "&", "&\f"), "&\f") != -1 && (x = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        A += je(E);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        A += rn(P);
        break;
      case 92:
        A += tn(Me() - 1, 7);
        continue;
      case 47:
        switch (Z()) {
          case 42:
          case 47:
            Fe(sn(nn(q(), Me()), r, t), d);
            break;
          default:
            A += "/";
        }
        break;
      case 123 * b:
        f[v++] = K(A) * x;
      case 125 * b:
      case 59:
      case 0:
        switch (E) {
          case 0:
          case 125:
            F = 0;
          case 59 + p:
            x == -1 && (A = C(A, /\f/g, "")), N > 0 && K(A) - y && Fe(N > 32 ? zr(A + ";", a, t, y - 1) : zr(C(A, " ", "") + ";", a, t, y - 2), d);
            break;
          case 59:
            A += ";";
          default:
            if (Fe(z = jr(A, r, t, v, p, o, f, $, I = [], u = [], y), i), E === 123)
              if (p === 0)
                ze(A, r, z, z, I, i, y, f, u);
              else
                switch (R === 99 && L(A, 3) === 110 ? 100 : R) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    ze(e, z, z, a && Fe(jr(e, z, z, 0, 0, o, f, $, o, I = [], y), u), o, u, y, f, a ? I : u);
                    break;
                  default:
                    ze(A, z, z, z, [""], u, 0, f, u);
                }
        }
        v = p = N = 0, b = x = 1, $ = A = "", y = c;
        break;
      case 58:
        y = 1 + K(A), N = P;
      default:
        if (b < 1) {
          if (E == 123)
            --b;
          else if (E == 125 && b++ == 0 && en() == 125)
            continue;
        }
        switch (A += Ue(E), E * b) {
          case 38:
            x = p > 0 ? 1 : (A += "\f", -1);
            break;
          case 44:
            f[v++] = (K(A) - 1) * x, x = 1;
            break;
          case 64:
            Z() === 45 && (A += je(q())), R = Z(), p = y = K($ = A += an(Me())), E++;
            break;
          case 45:
            P === 45 && K(A) == 2 && (b = 0);
        }
    }
  return i;
}
function jr(e, r, t, a, o, i, c, f, d, v, p) {
  for (var y = o - 1, R = o === 0 ? i : [""], N = vr(R), P = 0, b = 0, F = 0; P < a; ++P)
    for (var x = 0, E = _e(e, y + 1, y = Ht(b = c[P])), $ = e; x < N; ++x)
      ($ = et(b > 0 ? R[x] + " " + E : C(E, /&\f/g, R[x]))) && (d[F++] = $);
  return Be(e, r, t, o === 0 ? pr : f, d, v, p);
}
function sn(e, r, t) {
  return Be(e, r, t, dr, Ue(Qt()), _e(e, 2, -2), 0);
}
function zr(e, r, t, a) {
  return Be(e, r, t, hr, _e(e, 0, a), _e(e, a + 1, -1), a);
}
function ce(e, r) {
  for (var t = "", a = vr(e), o = 0; o < a; o++)
    t += r(e[o], o, e, r) || "";
  return t;
}
function cn(e, r, t, a) {
  switch (e.type) {
    case Gt:
      if (e.children.length)
        break;
    case Bt:
    case hr:
      return e.return = e.return || e.value;
    case dr:
      return "";
    case Qr:
      return e.return = e.value + "{" + ce(e.children, a) + "}";
    case pr:
      e.value = e.props.join(",");
  }
  return K(t = ce(e.children, a)) ? e.return = e.value + "{" + t + "}" : "";
}
function un(e) {
  var r = vr(e);
  return function(t, a, o, i) {
    for (var c = "", f = 0; f < r; f++)
      c += e[f](t, a, o, i) || "";
    return c;
  };
}
function fn(e) {
  return function(r) {
    r.root || (r = r.return) && e(r);
  };
}
function ln(e) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(t) {
    return r[t] === void 0 && (r[t] = e(t)), r[t];
  };
}
var dn = function(r, t, a) {
  for (var o = 0, i = 0; o = i, i = Z(), o === 38 && i === 12 && (t[a] = 1), !xe(i); )
    q();
  return we(r, U);
}, pn = function(r, t) {
  var a = -1, o = 44;
  do
    switch (xe(o)) {
      case 0:
        o === 38 && Z() === 12 && (t[a] = 1), r[a] += dn(U - 1, t, a);
        break;
      case 2:
        r[a] += je(o);
        break;
      case 4:
        if (o === 44) {
          r[++a] = Z() === 58 ? "&\f" : "", t[a] = r[a].length;
          break;
        }
      default:
        r[a] += Ue(o);
    }
  while (o = q());
  return r;
}, hn = function(r, t) {
  return nt(pn(tt(r), t));
}, Lr = /* @__PURE__ */ new WeakMap(), vn = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var t = r.value, a = r.parent, o = r.column === a.column && r.line === a.line; a.type !== "rule"; )
      if (a = a.parent, !a)
        return;
    if (!(r.props.length === 1 && t.charCodeAt(0) !== 58 && !Lr.get(a)) && !o) {
      Lr.set(r, !0);
      for (var i = [], c = hn(t, i), f = a.props, d = 0, v = 0; d < c.length; d++)
        for (var p = 0; p < f.length; p++, v++)
          r.props[v] = i[d] ? c[d].replace(/&\f/g, f[p]) : f[p] + " " + c[d];
    }
  }
}, mn = function(r) {
  if (r.type === "decl") {
    var t = r.value;
    // charcode for l
    t.charCodeAt(0) === 108 && // charcode for b
    t.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
}, yn = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", En = function(r) {
  return r.type === "comm" && r.children.indexOf(yn) > -1;
}, gn = function(r) {
  return function(t, a, o) {
    if (!(t.type !== "rule" || r.compat)) {
      var i = t.value.match(/(:first|:nth|:nth-last)-child/g);
      if (i) {
        for (var c = !!t.parent, f = c ? t.parent.children : (
          // global rule at the root level
          o
        ), d = f.length - 1; d >= 0; d--) {
          var v = f[d];
          if (v.line < t.line)
            break;
          if (v.column < t.column) {
            if (En(v))
              return;
            break;
          }
        }
        i.forEach(function(p) {
          console.error('The pseudo class "' + p + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + p.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, at = function(r) {
  return r.type.charCodeAt(1) === 105 && r.type.charCodeAt(0) === 64;
}, bn = function(r, t) {
  for (var a = r - 1; a >= 0; a--)
    if (!at(t[a]))
      return !0;
  return !1;
}, Vr = function(r) {
  r.type = "", r.value = "", r.return = "", r.children = "", r.props = "";
}, _n = function(r, t, a) {
  at(r) && (r.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), Vr(r)) : bn(t, a) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), Vr(r)));
};
function ot(e, r) {
  switch (Kt(e, r)) {
    case 5103:
      return w + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return w + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return w + e + Ye + e + V + e + e;
    case 6828:
    case 4268:
      return w + e + V + e + e;
    case 6165:
      return w + e + V + "flex-" + e + e;
    case 5187:
      return w + e + C(e, /(\w+).+(:[^]+)/, w + "box-$1$2" + V + "flex-$1$2") + e;
    case 5443:
      return w + e + V + "flex-item-" + C(e, /flex-|-self/, "") + e;
    case 4675:
      return w + e + V + "flex-line-pack" + C(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return w + e + V + C(e, "shrink", "negative") + e;
    case 5292:
      return w + e + V + C(e, "basis", "preferred-size") + e;
    case 6060:
      return w + "box-" + C(e, "-grow", "") + w + e + V + C(e, "grow", "positive") + e;
    case 4554:
      return w + C(e, /([^-])(transform)/g, "$1" + w + "$2") + e;
    case 6187:
      return C(C(C(e, /(zoom-|grab)/, w + "$1"), /(image-set)/, w + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return C(e, /(image-set\([^]*)/, w + "$1$`$1");
    case 4968:
      return C(C(e, /(.+:)(flex-)?(.*)/, w + "box-pack:$3" + V + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + w + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return C(e, /(.+)-inline(.+)/, w + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (K(e) - 1 - r > 6)
        switch (L(e, r + 1)) {
          case 109:
            if (L(e, r + 4) !== 45)
              break;
          case 102:
            return C(e, /(.+:)(.+)-([^]+)/, "$1" + w + "$2-$3$1" + Ye + (L(e, r + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~ir(e, "stretch") ? ot(C(e, "stretch", "fill-available"), r) + e : e;
        }
      break;
    case 4949:
      if (L(e, r + 1) !== 115)
        break;
    case 6444:
      switch (L(e, K(e) - 3 - (~ir(e, "!important") && 10))) {
        case 107:
          return C(e, ":", ":" + w) + e;
        case 101:
          return C(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + w + (L(e, 14) === 45 ? "inline-" : "") + "box$3$1" + w + "$2$3$1" + V + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (L(e, r + 11)) {
        case 114:
          return w + e + V + C(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return w + e + V + C(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return w + e + V + C(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return w + e + V + e + e;
  }
  return e;
}
var xn = function(r, t, a, o) {
  if (r.length > -1 && !r.return)
    switch (r.type) {
      case hr:
        r.return = ot(r.value, r.length);
        break;
      case Qr:
        return ce([be(r, {
          value: C(r.value, "@", "@" + w)
        })], o);
      case pr:
        if (r.length)
          return Xt(r.props, function(i) {
            switch (Zt(i, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return ce([be(r, {
                  props: [C(i, /:(read-\w+)/, ":" + Ye + "$1")]
                })], o);
              case "::placeholder":
                return ce([be(r, {
                  props: [C(i, /:(plac\w+)/, ":" + w + "input-$1")]
                }), be(r, {
                  props: [C(i, /:(plac\w+)/, ":" + Ye + "$1")]
                }), be(r, {
                  props: [C(i, /:(plac\w+)/, V + "input-$1")]
                })], o);
            }
            return "";
          });
    }
}, Sn = [xn], wn = function(r) {
  var t = r.key;
  if (process.env.NODE_ENV !== "production" && !t)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (t === "css") {
    var a = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(a, function(b) {
      var F = b.getAttribute("data-emotion");
      F.indexOf(" ") !== -1 && (document.head.appendChild(b), b.setAttribute("data-s", ""));
    });
  }
  var o = r.stylisPlugins || Sn;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(t))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + t + '" was passed');
  var i = {}, c, f = [];
  c = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + t + ' "]'),
    function(b) {
      for (var F = b.getAttribute("data-emotion").split(" "), x = 1; x < F.length; x++)
        i[F[x]] = !0;
      f.push(b);
    }
  );
  var d, v = [vn, mn];
  process.env.NODE_ENV !== "production" && v.push(gn({
    get compat() {
      return P.compat;
    }
  }), _n);
  {
    var p, y = [cn, process.env.NODE_ENV !== "production" ? function(b) {
      b.root || (b.return ? p.insert(b.return) : b.value && b.type !== dr && p.insert(b.value + "{}"));
    } : fn(function(b) {
      p.insert(b);
    })], R = un(v.concat(o, y)), N = function(F) {
      return ce(on(F), R);
    };
    d = function(F, x, E, $) {
      p = E, process.env.NODE_ENV !== "production" && x.map !== void 0 && (p = {
        insert: function(u) {
          E.insert(u + x.map);
        }
      }), N(F ? F + "{" + x.styles + "}" : x.styles), $ && (P.inserted[x.name] = !0);
    };
  }
  var P = {
    key: t,
    sheet: new qt({
      key: t,
      container: c,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: i,
    registered: {},
    insert: d
  };
  return P.sheet.hydrate(f), P;
}, cr = { exports: {} }, T = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Yr;
function Cn() {
  if (Yr)
    return T;
  Yr = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, c = e ? Symbol.for("react.provider") : 60109, f = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, v = e ? Symbol.for("react.concurrent_mode") : 60111, p = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, R = e ? Symbol.for("react.suspense_list") : 60120, N = e ? Symbol.for("react.memo") : 60115, P = e ? Symbol.for("react.lazy") : 60116, b = e ? Symbol.for("react.block") : 60121, F = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
  function $(u) {
    if (typeof u == "object" && u !== null) {
      var z = u.$$typeof;
      switch (z) {
        case r:
          switch (u = u.type, u) {
            case d:
            case v:
            case a:
            case i:
            case o:
            case y:
              return u;
            default:
              switch (u = u && u.$$typeof, u) {
                case f:
                case p:
                case P:
                case N:
                case c:
                  return u;
                default:
                  return z;
              }
          }
        case t:
          return z;
      }
    }
  }
  function I(u) {
    return $(u) === v;
  }
  return T.AsyncMode = d, T.ConcurrentMode = v, T.ContextConsumer = f, T.ContextProvider = c, T.Element = r, T.ForwardRef = p, T.Fragment = a, T.Lazy = P, T.Memo = N, T.Portal = t, T.Profiler = i, T.StrictMode = o, T.Suspense = y, T.isAsyncMode = function(u) {
    return I(u) || $(u) === d;
  }, T.isConcurrentMode = I, T.isContextConsumer = function(u) {
    return $(u) === f;
  }, T.isContextProvider = function(u) {
    return $(u) === c;
  }, T.isElement = function(u) {
    return typeof u == "object" && u !== null && u.$$typeof === r;
  }, T.isForwardRef = function(u) {
    return $(u) === p;
  }, T.isFragment = function(u) {
    return $(u) === a;
  }, T.isLazy = function(u) {
    return $(u) === P;
  }, T.isMemo = function(u) {
    return $(u) === N;
  }, T.isPortal = function(u) {
    return $(u) === t;
  }, T.isProfiler = function(u) {
    return $(u) === i;
  }, T.isStrictMode = function(u) {
    return $(u) === o;
  }, T.isSuspense = function(u) {
    return $(u) === y;
  }, T.isValidElementType = function(u) {
    return typeof u == "string" || typeof u == "function" || u === a || u === v || u === i || u === o || u === y || u === R || typeof u == "object" && u !== null && (u.$$typeof === P || u.$$typeof === N || u.$$typeof === c || u.$$typeof === f || u.$$typeof === p || u.$$typeof === F || u.$$typeof === x || u.$$typeof === E || u.$$typeof === b);
  }, T.typeOf = $, T;
}
var O = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Wr;
function Rn() {
  return Wr || (Wr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, c = e ? Symbol.for("react.provider") : 60109, f = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, v = e ? Symbol.for("react.concurrent_mode") : 60111, p = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, R = e ? Symbol.for("react.suspense_list") : 60120, N = e ? Symbol.for("react.memo") : 60115, P = e ? Symbol.for("react.lazy") : 60116, b = e ? Symbol.for("react.block") : 60121, F = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
    function $(h) {
      return typeof h == "string" || typeof h == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      h === a || h === v || h === i || h === o || h === y || h === R || typeof h == "object" && h !== null && (h.$$typeof === P || h.$$typeof === N || h.$$typeof === c || h.$$typeof === f || h.$$typeof === p || h.$$typeof === F || h.$$typeof === x || h.$$typeof === E || h.$$typeof === b);
    }
    function I(h) {
      if (typeof h == "object" && h !== null) {
        var me = h.$$typeof;
        switch (me) {
          case r:
            var oe = h.type;
            switch (oe) {
              case d:
              case v:
              case a:
              case i:
              case o:
              case y:
                return oe;
              default:
                var te = oe && oe.$$typeof;
                switch (te) {
                  case f:
                  case p:
                  case P:
                  case N:
                  case c:
                    return te;
                  default:
                    return me;
                }
            }
          case t:
            return me;
        }
      }
    }
    var u = d, z = v, A = f, Ge = c, Ce = r, He = p, Je = a, Re = P, H = N, X = t, re = i, Te = o, Oe = y, le = !1;
    function Pe(h) {
      return le || (le = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), de(h) || I(h) === d;
    }
    function de(h) {
      return I(h) === v;
    }
    function Ae(h) {
      return I(h) === f;
    }
    function $e(h) {
      return I(h) === c;
    }
    function Ne(h) {
      return typeof h == "object" && h !== null && h.$$typeof === r;
    }
    function Ke(h) {
      return I(h) === p;
    }
    function Ze(h) {
      return I(h) === a;
    }
    function pe(h) {
      return I(h) === P;
    }
    function he(h) {
      return I(h) === N;
    }
    function ne(h) {
      return I(h) === t;
    }
    function ve(h) {
      return I(h) === i;
    }
    function ae(h) {
      return I(h) === o;
    }
    function Xe(h) {
      return I(h) === y;
    }
    O.AsyncMode = u, O.ConcurrentMode = z, O.ContextConsumer = A, O.ContextProvider = Ge, O.Element = Ce, O.ForwardRef = He, O.Fragment = Je, O.Lazy = Re, O.Memo = H, O.Portal = X, O.Profiler = re, O.StrictMode = Te, O.Suspense = Oe, O.isAsyncMode = Pe, O.isConcurrentMode = de, O.isContextConsumer = Ae, O.isContextProvider = $e, O.isElement = Ne, O.isForwardRef = Ke, O.isFragment = Ze, O.isLazy = pe, O.isMemo = he, O.isPortal = ne, O.isProfiler = ve, O.isStrictMode = ae, O.isSuspense = Xe, O.isValidElementType = $, O.typeOf = I;
  }()), O;
}
process.env.NODE_ENV === "production" ? cr.exports = Cn() : cr.exports = Rn();
var Tn = cr.exports, it = Tn, On = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Pn = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, st = {};
st[it.ForwardRef] = On;
st[it.Memo] = Pn;
var An = !0;
function $n(e, r, t) {
  var a = "";
  return t.split(" ").forEach(function(o) {
    e[o] !== void 0 ? r.push(e[o] + ";") : a += o + " ";
  }), a;
}
var ct = function(r, t, a) {
  var o = r.key + "-" + t.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (a === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  An === !1) && r.registered[o] === void 0 && (r.registered[o] = t.styles);
}, Nn = function(r, t, a) {
  ct(r, t, a);
  var o = r.key + "-" + t.name;
  if (r.inserted[t.name] === void 0) {
    var i = t;
    do
      r.insert(t === i ? "." + o : "", i, r.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function kn(e) {
  for (var r = 0, t, a = 0, o = e.length; o >= 4; ++a, o -= 4)
    t = e.charCodeAt(a) & 255 | (e.charCodeAt(++a) & 255) << 8 | (e.charCodeAt(++a) & 255) << 16 | (e.charCodeAt(++a) & 255) << 24, t = /* Math.imul(k, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), t ^= /* k >>> r: */
    t >>> 24, r = /* Math.imul(k, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      r ^= (e.charCodeAt(a + 2) & 255) << 16;
    case 2:
      r ^= (e.charCodeAt(a + 1) & 255) << 8;
    case 1:
      r ^= e.charCodeAt(a) & 255, r = /* Math.imul(h, m): */
      (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  }
  return r ^= r >>> 13, r = /* Math.imul(h, m): */
  (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), ((r ^ r >>> 15) >>> 0).toString(36);
}
var In = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Ur = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, Dn = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", Fn = /[A-Z]|^ms/g, ut = /_EMO_([^_]+?)_([^]*?)_EMO_/g, mr = function(r) {
  return r.charCodeAt(1) === 45;
}, qr = function(r) {
  return r != null && typeof r != "boolean";
}, ar = /* @__PURE__ */ ln(function(e) {
  return mr(e) ? e : e.replace(Fn, "-$&").toLowerCase();
}), We = function(r, t) {
  switch (r) {
    case "animation":
    case "animationName":
      if (typeof t == "string")
        return t.replace(ut, function(a, o, i) {
          return J = {
            name: o,
            styles: i,
            next: J
          }, o;
        });
  }
  return In[r] !== 1 && !mr(r) && typeof t == "number" && t !== 0 ? t + "px" : t;
};
if (process.env.NODE_ENV !== "production") {
  var Mn = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, jn = ["normal", "none", "initial", "inherit", "unset"], zn = We, Ln = /^-ms-/, Vn = /-(.)/g, Br = {};
  We = function(r, t) {
    if (r === "content" && (typeof t != "string" || jn.indexOf(t) === -1 && !Mn.test(t) && (t.charAt(0) !== t.charAt(t.length - 1) || t.charAt(0) !== '"' && t.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + t + "\"'`");
    var a = zn(r, t);
    return a !== "" && !mr(r) && r.indexOf("-") !== -1 && Br[r] === void 0 && (Br[r] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + r.replace(Ln, "ms-").replace(Vn, function(o, i) {
      return i.toUpperCase();
    }) + "?")), a;
  };
}
var ft = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function Se(e, r, t) {
  if (t == null)
    return "";
  if (t.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && t.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(ft);
    return t;
  }
  switch (typeof t) {
    case "boolean":
      return "";
    case "object": {
      if (t.anim === 1)
        return J = {
          name: t.name,
          styles: t.styles,
          next: J
        }, t.name;
      if (t.styles !== void 0) {
        var a = t.next;
        if (a !== void 0)
          for (; a !== void 0; )
            J = {
              name: a.name,
              styles: a.styles,
              next: J
            }, a = a.next;
        var o = t.styles + ";";
        return process.env.NODE_ENV !== "production" && t.map !== void 0 && (o += t.map), o;
      }
      return Yn(e, r, t);
    }
    case "function": {
      if (e !== void 0) {
        var i = J, c = t(e);
        return J = i, Se(e, r, c);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var f = [], d = t.replace(ut, function(p, y, R) {
          var N = "animation" + f.length;
          return f.push("const " + N + " = keyframes`" + R.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + N + "}";
        });
        f.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(f, ["`" + d + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + d + "`"));
      }
      break;
  }
  if (r == null)
    return t;
  var v = r[t];
  return v !== void 0 ? v : t;
}
function Yn(e, r, t) {
  var a = "";
  if (Array.isArray(t))
    for (var o = 0; o < t.length; o++)
      a += Se(e, r, t[o]) + ";";
  else
    for (var i in t) {
      var c = t[i];
      if (typeof c != "object")
        r != null && r[c] !== void 0 ? a += i + "{" + r[c] + "}" : qr(c) && (a += ar(i) + ":" + We(i, c) + ";");
      else {
        if (i === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(ft);
        if (Array.isArray(c) && typeof c[0] == "string" && (r == null || r[c[0]] === void 0))
          for (var f = 0; f < c.length; f++)
            qr(c[f]) && (a += ar(i) + ":" + We(i, c[f]) + ";");
        else {
          var d = Se(e, r, c);
          switch (i) {
            case "animation":
            case "animationName": {
              a += ar(i) + ":" + d + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && i === "undefined" && console.error(Dn), a += i + "{" + d + "}";
          }
        }
      }
    }
  return a;
}
var Gr = /label:\s*([^\s;\n{]+)\s*(;|$)/g, lt;
process.env.NODE_ENV !== "production" && (lt = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var J, Hr = function(r, t, a) {
  if (r.length === 1 && typeof r[0] == "object" && r[0] !== null && r[0].styles !== void 0)
    return r[0];
  var o = !0, i = "";
  J = void 0;
  var c = r[0];
  c == null || c.raw === void 0 ? (o = !1, i += Se(a, t, c)) : (process.env.NODE_ENV !== "production" && c[0] === void 0 && console.error(Ur), i += c[0]);
  for (var f = 1; f < r.length; f++)
    i += Se(a, t, r[f]), o && (process.env.NODE_ENV !== "production" && c[f] === void 0 && console.error(Ur), i += c[f]);
  var d;
  process.env.NODE_ENV !== "production" && (i = i.replace(lt, function(R) {
    return d = R, "";
  })), Gr.lastIndex = 0;
  for (var v = "", p; (p = Gr.exec(i)) !== null; )
    v += "-" + // $FlowFixMe we know it's not null
    p[1];
  var y = kn(i) + v;
  return process.env.NODE_ENV !== "production" ? {
    name: y,
    styles: i,
    map: d,
    next: J,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: y,
    styles: i,
    next: J
  };
}, Wn = function(r) {
  return r();
}, Un = ee["useInsertionEffect"] ? ee["useInsertionEffect"] : !1, qn = Un || Wn, yr = {}.hasOwnProperty, Er = /* @__PURE__ */ ee.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ wn({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (Er.displayName = "EmotionCacheContext");
Er.Provider;
var Bn = function(r) {
  return /* @__PURE__ */ lr(function(t, a) {
    var o = Ft(Er);
    return r(t, o, a);
  });
}, dt = /* @__PURE__ */ ee.createContext({});
process.env.NODE_ENV !== "production" && (dt.displayName = "EmotionThemeContext");
var Jr = function(r) {
  var t = r.split(".");
  return t[t.length - 1];
}, Gn = function(r) {
  var t = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(r);
  if (t || (t = /^([A-Za-z0-9$.]+)@/.exec(r), t))
    return Jr(t[1]);
}, Hn = /* @__PURE__ */ new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]), Jn = function(r) {
  return r.replace(/\$/g, "-");
}, Kn = function(r) {
  if (r)
    for (var t = r.split(`
`), a = 0; a < t.length; a++) {
      var o = Gn(t[a]);
      if (o) {
        if (Hn.has(o))
          break;
        if (/^[A-Z]/.test(o))
          return Jn(o);
      }
    }
}, ur = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", fr = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", Zn = function(r, t) {
  if (process.env.NODE_ENV !== "production" && typeof t.css == "string" && // check if there is a css declaration
  t.css.indexOf(":") !== -1)
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + t.css + "`");
  var a = {};
  for (var o in t)
    yr.call(t, o) && (a[o] = t[o]);
  if (a[ur] = r, process.env.NODE_ENV !== "production" && t.css && (typeof t.css != "object" || typeof t.css.name != "string" || t.css.name.indexOf("-") === -1)) {
    var i = Kn(new Error().stack);
    i && (a[fr] = i);
  }
  return a;
}, Xn = function(r) {
  var t = r.cache, a = r.serialized, o = r.isStringTag;
  return ct(t, a, o), qn(function() {
    return Nn(t, a, o);
  }), null;
}, pt = /* @__PURE__ */ Bn(function(e, r, t) {
  var a = e.css;
  typeof a == "string" && r.registered[a] !== void 0 && (a = r.registered[a]);
  var o = e[ur], i = [a], c = "";
  typeof e.className == "string" ? c = $n(r.registered, i, e.className) : e.className != null && (c = e.className + " ");
  var f = Hr(i, void 0, ee.useContext(dt));
  if (process.env.NODE_ENV !== "production" && f.name.indexOf("-") === -1) {
    var d = e[fr];
    d && (f = Hr([f, "label:" + d + ";"]));
  }
  c += r.key + "-" + f.name;
  var v = {};
  for (var p in e)
    yr.call(e, p) && p !== "css" && p !== ur && (process.env.NODE_ENV === "production" || p !== fr) && (v[p] = e[p]);
  return v.ref = t, v.className = c, /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement(Xn, {
    cache: r,
    serialized: f,
    isStringTag: typeof o == "string"
  }), /* @__PURE__ */ ee.createElement(o, v));
});
process.env.NODE_ENV !== "production" && (pt.displayName = "EmotionCssPropInternal");
var Qn = pt;
function W(e, r, t) {
  return yr.call(r, "css") ? Mr.jsx(Qn, Zn(e, r), t) : Mr.jsx(e, r, t);
}
const ea = [
  "white",
  "blackAlpha",
  "gray",
  "grayBlue",
  "red",
  "orange",
  "yellow",
  "green",
  "blue",
  "cyan",
  "purple",
  "techPink",
  "techPurple"
];
function ra(e) {
  let r;
  return ea.includes(e) ? e == "gray" || e == "grayBlue" ? r = G`
        background-color: ${Le(`--${Ve}-${e}-05`)};
      ` : r = G`
        background-color: ${Le(`--${Ve}-${e}-01`)};
      ` : r = G`
      background-color: ${e};
    `, r;
}
function ta(e) {
  const [r, t, a, o] = gr(e);
  return G`
    width: ${r};
    height: ${t};
    font-size: ${a};
    line-height: ${o};
    border-radius: 8px;
  `;
}
function na(e) {
  const [r, t, a, o] = gr(e);
  return G`
    width: ${r};
    height: ${t};
    font-size: ${a};
    line-height: ${o};
    border-radius: 50%;
  `;
}
function aa(e) {
  return G`
    ${ra(e)};
    display: inline-flex;
    overflow: hidden;
    word-wrap: break-word;
    white-space: nowrap;
    color: ${Le(`--${Ve}-white-01`)};
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 4px;
  `;
}
function gr(e) {
  let r, t, a, o;
  switch (e) {
    case "large": {
      r = "64px", t = "64px", a = "24px", o = "32px";
      break;
    }
    case "medium": {
      r = "40px", t = "40px", a = "14px", o = "22px";
      break;
    }
    case "small": {
      r = "32px", t = "32px", a = "14px", o = "22px";
      break;
    }
  }
  return [r, t, a, o];
}
function ht(e) {
  const r = e.colorScheme ?? "blue", t = e.size ?? "small", a = e.shape ?? "circle", o = aa(r);
  let i;
  switch (a) {
    case "circle": {
      i = na(t);
      break;
    }
    case "square": {
      i = ta(t);
      break;
    }
  }
  return G`
    ${o};
    ${i};
  `;
}
function oa(e) {
  switch (e) {
    case "circle":
      return "50%";
    case "square":
      return "4px";
  }
}
function ia(e) {
  let r, t;
  switch (e) {
    case "large": {
      r = 28, t = 28;
      break;
    }
    case "medium": {
      r = 18, t = 18;
      break;
    }
    case "small": {
      r = 14, t = 14;
      break;
    }
  }
  return G`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: ${r}px;
    font-size: ${r}px;
    height: ${t}px;
  `;
}
const sa = (e) => {
  const r = e.colorScheme ?? "blue", t = e.size ?? "small", a = e.shape ?? "circle";
  let o;
  switch (t) {
    default:
    case "large": {
      o = "28px";
      break;
    }
    case "medium": {
      o = "18px";
      break;
    }
    case "small": {
      o = "14px";
      break;
    }
  }
  const i = e.icon ?? W(zt, { size: o }), c = {
    ...e,
    colorScheme: r,
    size: t,
    shape: a,
    icon: i
  };
  return W("div", { css: ht(c), children: W("div", { css: ia(c.size), children: c.icon }) });
};
function ca(e, r) {
  if (e.current != null && r.current != null) {
    const t = e.current.clientWidth, a = r.current.offsetWidth, o = a / (t + 8);
    a && o < 1 ? e.current.style.transform = `scale(${o})` : e.current.style.transform = "scale(1)";
  }
}
const ua = (e) => {
  const r = e.colorScheme ?? "blue", t = e.size ?? "small", a = e.shape ?? "circle", o = {
    ...e,
    colorScheme: r,
    size: t,
    shape: a
  }, i = Ir(null), c = Ir(null);
  return Mt(() => {
    ca(i, c);
  }, [o.text, o.size]), W("div", { ref: c, css: ht(o), children: W("span", { ref: i, children: e.text }) });
}, fa = (e) => {
  const { size: r = "small", shape: t = "circle" } = e, [a, o] = gr(r);
  return W(Lt, { src: e.src, width: a, height: o, radius: oa(t) });
}, br = jt(void 0);
br.displayName = "AvatarGroupContext";
const la = G`
  vertical-align: middle;
  display: inline-flex;
`, vt = lr((e, r) => W(br.Consumer, { children: (t) => {
  const { colorScheme: a = (t == null ? void 0 : t.colorScheme) ?? "gray", size: o = (t == null ? void 0 : t.size) ?? "small", shape: i = "circle", text: c = void 0, src: f = void 0, icon: d = void 0, ...v } = e;
  let p;
  return e.src != null ? p = W(fa, { colorScheme: a, size: o, shape: i, text: c, src: f, icon: d }) : e.text != null ? p = W(ua, { colorScheme: a, size: o, shape: i, text: c, src: f, icon: d }) : p = W(sa, { colorScheme: a, size: o, shape: i, text: c, src: f, icon: d }), W("div", { css: [la, Zr(e)], ref: r, ...Xr(v), children: p });
} }));
vt.displayName = "Avatar";
const da = G`
  display: flex;
  flex-direction: row;
  align-items: center;
`, pa = lr((e, r) => {
  const { zIndexAscend: t, maxCount: a = Number.MAX_VALUE, colorScheme: o, size: i, ...c } = e, f = De.count(e.children);
  let d;
  f <= a ? d = De.toArray(e.children) : d = De.toArray(e.children).splice(0, a), f > a && (d = [
    ...d,
    W(vt, { colorScheme: "gray", text: `+${f - a}` }, "illa-more-avatar")
  ]);
  let v;
  switch (e.size) {
    default:
    case "small":
      v = "-8px";
      break;
    case "medium":
      v = "-12px";
      break;
    case "large":
      v = "-20px";
      break;
  }
  const p = De.map(d, (y, R) => {
    const P = G`
        margin-left: ${R === 0 ? "0px" : v};
        border: solid 2px ${Le(`--${Ve}-white-01`)};
        border-radius: 50%;
        z-index: ${t ? R : d.length - R};
      `;
    return W("span", { css: P, children: y });
  });
  return W(br.Provider, { value: {
    zIndexAscend: t,
    maxCount: a,
    colorScheme: o,
    size: i
  }, children: W("div", { css: G`
            display: inline-block;
            ${da};
            ${Zr(e)};
          `, ref: r, ...Xr(c), children: p }) });
});
pa.displayName = "AvatarGroup";
export {
  vt as Avatar,
  pa as AvatarGroup,
  br as AvatarGroupContext
};
//# sourceMappingURL=index.js.map
